import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { AppColors } from "../../../utility/AppColors";
import { ScreenBGGradientView } from "../../../common/CommonView";
import { AppFontStyle } from "../../../styles/AppFontStyle";

const FallbackUI: React.FC = () => {
  const handleReload = () => {
    window.location.href = window.location.origin;
  };

  return (
    <View style={styles.container}>
      <ScreenBGGradientView />
      <View style={styles.content}>
        {/* Error Icon */}
        <View style={styles.iconContainer}>
          <Text style={styles.iconText}>⚠️</Text>
        </View>

        {/* Error Message */}
        <Text style={styles.title}>Something went wrong</Text>
        <Text style={styles.message}>
          We encountered an unexpected error. Please try refreshing the page.
        </Text>

        {/* Action Buttons */}
        <View style={styles.buttonContainer}>
          <TouchableOpacity style={styles.button} onPress={handleReload}>
            <Text style={styles.buttonText}>Reload Page</Text>
          </TouchableOpacity>
        </View>

        {/* Additional Help Text */}
        <Text style={styles.helpText}>
          If the problem persists, please contact support
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: AppColors.black_121212,
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    zIndex: 1,
  },
  iconContainer: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: AppColors.appGrayColor_1C1C1C,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 24,
  },
  iconText: {
    fontSize: 40,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    color: AppColors.white,
    marginBottom: 12,
  },
  message: {
    fontSize: 16,
    textAlign: "center",
    color: AppColors.gray_A3A3A3,
    marginBottom: 32,
    maxWidth: 400,
    lineHeight: 24,
  },
  buttonContainer: {
    flexDirection: "row",
    gap: 12,
    marginBottom: 24,
  },
  button: {
    backgroundColor: AppColors.koBrandRed,
    paddingHorizontal: 32,
    paddingVertical: 14,
    borderRadius: 8,
    minWidth: 150,
    alignItems: "center",
  },
  buttonText: {
    color: AppColors.white,
    fontSize: 16,
    fontWeight: "600",
  },
  helpText: {
    fontSize: 14,
    color: AppColors.grayColor_505050,
    textAlign: "center",
  },
});

export default FallbackUI;
